// extracted by mini-css-extract-plugin
export var addressFields = "_o3-0";
export var animationContainer = "_o3-1";
export var footer = "_o3-2";
export var lineItems = "_o3-3";
export var modalContent = "_o3-4";
export var orderName = "_o3-5";
export var strong = "_o3-6";
export var warning = "_o3-7";